import { UseDocumentTestResultType } from './remarkFromAdminType'

const useRemarkFromAdmin = (props: UseDocumentTestResultType) => {
    const {} = props

    return {}
}

export default useRemarkFromAdmin
